// extracted by mini-css-extract-plugin
export var introContainer = "FriendsAndPartners-module--introContainer--Dl2vd";
export var introContent = "FriendsAndPartners-module--introContent--Eyf47";
export var spacing = "FriendsAndPartners-module--spacing--jqLVe";
export var heading = "FriendsAndPartners-module--heading--j44dB";
export var title = "FriendsAndPartners-module--title--zRbWv";
export var text = "FriendsAndPartners-module--text--9wNRG";